import React from 'react';
import Head from 'next/head';
import BaseLayout from '@/components/common/BaseLayout';
import TermsOfService from '../components/TermsOfService';
import TAGS from '../../public/headJson.json';
import RouteName from '../utils/route.util';

const TermsOfServicePage = () => {
  return (
    <>
      <Head>
        {/* Primary Meta Tags */}
        <title>{TAGS.terms.title}</title>
        <meta name="title" content={TAGS.terms.title} />
        <meta name="description" content={TAGS.terms.desc} />
        <link rel="canonical" href={`${RouteName.termsAndConditions}/`} />

        {/* Facebook */}
        <meta property="og:url" content={RouteName.termsAndConditions} />
        <meta property="og:title" content={TAGS.terms.title} />
        <meta property="og:description" content={TAGS.terms.desc} />

        {/* Twitter */}
        <meta property="twitter:url" content={RouteName.termsAndConditions} />
        <meta property="twitter:title" content={TAGS.terms.title} />
        <meta property="twitter:description" content={TAGS.terms.desc} />
      </Head>
      <BaseLayout category={undefined}>
        <TermsOfService />
      </BaseLayout>
    </>
  );
};

export default TermsOfServicePage;
